"use client";
import React from 'react';
import { handleContextMenu } from './const';
const Card = ({ title, desc, img }) => {
let width = window.innerWidth;
  return (
    <div className={`text-center hover-up-animation ${width > 500 ? "mt-5 p-3" : "mt-0 p-1"}`}>
      <img
      onContextMenu={handleContextMenu}
      className='step-icon'
        src={img}
        alt={title}
      />
      <p className='sub-heading mt-2 mb-2'>{title}</p>
      <p>{desc}</p>
    </div>
  );
};


export default Card;
